import styled, { css } from 'styled-components';
import { WorkOutlineOutlined as WorkOutlineOutlinedIcon } from '@mui/icons-material';
import { Chip, Typography } from '../../design-system';

export const CardsWrapper = styled.div<{ hasActions?: boolean }>`
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: max-content 1fr;
  grid-row-gap: var(--spacing-6);

  overflow: hidden;
  padding: 0 var(--spacing-6);
  margin: 0 calc(-1 * var(--spacing-6));

  ${(props) =>
    !props.hasActions &&
    css`
      & > ${CardsActions} {
        display: none;
      }

      grid-template-rows: 1fr;
    `}
`;

export const CardsActions = styled.div`
  display: grid;
  grid-template-rows: 4rem;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  align-content: center;

  height: 3rem;
  padding: 1rem var(--spacing-6) 0;
  margin: 0 calc(-1 * var(--spacing-6)) 0 -3.3rem;

  & > *:nth-child(n + 3) {
    margin-left: var(--spacing-3);
  }
  & > label {
    column-gap: 0;
  }
  & > label > *:nth-child(1) {
    margin: 0;
    width: 4rem;
    height: 4rem;
  }
`;

export const Cards = styled.div.attrs({
  className: 'table-cards',
})`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: var(--spacing-6);

  height: 100%;
  padding: 0 var(--spacing-6);
  margin: 0 calc(-1 * var(--spacing-6));
  overflow-y: auto;
`;

export const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
`;

export const CardActions = styled.div<{ isCenter?: boolean }>`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  align-content: space-between;
  justify-items: center;
  margin-left: -0.9rem;

  & > * {
    margin: 0 !important;
    width: 4rem;
    height: 4rem;
  }

  ${(props) =>
    props.isCenter &&
    css`
      align-content: center;
    `}
`;

export const CardBase = styled.div`
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: var(--spacing-1);

  height: 10rem;
  padding: var(--spacing-3);
  padding-left: 11.2rem;
  position: relative;

  background-color: var(--white);
  border-radius: var(--border-radius-6);
  overflow: hidden;

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
`;

export const ContainerPhotoBase = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  position: absolute;
  left: 0;
  height: 10rem;
  width: 10rem;

  cursor: pointer;
  background-color: #bdbdbd; /*  var(--gray-60); */

  & > svg {
    width: 4rem;
    height: 4rem;
    color: var(--white);
  }
`;

const ContainerPhotoImg = styled.img`
  height: 10rem;
  width: 10rem;
  object-fit: cover;
`;

interface ContainerPhotoProps {
  src: string;
  onClick: (e: any) => void;
}

export const ContainerPhoto = ({ src, onClick }: ContainerPhotoProps) => {
  return (
    <ContainerPhotoBase>
      {src && <ContainerPhotoImg src={src} onClick={onClick} />}
      {!src && <WorkOutlineOutlinedIcon />}
    </ContainerPhotoBase>
  );
};

interface CardInfoProps {
  column?: string;
}

export const CardInfo = styled.div<CardInfoProps>`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: var(--spacing-3);
  align-items: center;

  ${(props) =>
    props.column &&
    css`
      grid-template-columns: ${props.column};
      grid-column-gap: var(--spacing-1);
    `}
`;

export const AddressTypography = styled(Typography)`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
  grid-auto-flow: column;
  grid-column-gap: var(--spacing-2);
`;

export const ChipButton = styled(Chip)`
  cursor: pointer;
`;
